const userAgent = () => {
  const agent = window.navigator.userAgent;
  const regex = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;
  let mobileDeviceName;
  let isMobile = Boolean(agent.match(regex));
  if (isMobile) {
    mobileDeviceName = agent.match(regex)[0];
  } else {
    mobileDeviceName = 'Unknown';
  }

  return {
    isMobile,
    mobileDeviceName
  }
}

export default userAgent;